import { useEffect, useState } from "react"
import { GoogleAuthProvider, signInWithPopup, getAuth, onAuthStateChanged, signOut} from "firebase/auth";
import auth from "../firebase.init";

const googleProvider = new GoogleAuthProvider();


const useFirebase = () =>{
 const [userGoogle, setUser] = useState({});

    const handleGoogleSignIn =()=>{

        signInWithPopup(auth,googleProvider)
       .then(result =>{
           const user = result.user;
           setUser(user);
      
    
       })
       .catch(error =>{
           const errorMessage = error.message;
           console.log('click', errorMessage)
       });
      
    };

    const handleGoogleSignOut = () =>{
        signOut(auth)
        .then(()=>{})
        .catch(error =>{
            const errorMessage = error.message;
            console.log('click', errorMessage)
        });  
    }

    useEffect( ()=>{
        onAuthStateChanged(auth, user=>{
            setUser(user);
        })
    } ,[]);

    console.log('click',userGoogle);
    return{
        userGoogle,
        handleGoogleSignIn,
        handleGoogleSignOut
    }

}

export default useFirebase;